export function isFullscreenSupported(): boolean {
  const el = document.createElement('div');
  return (
    ('requestFullscreen' in el && typeof el.requestFullscreen === 'function') ||
    ('mozRequestFullScreen' in el && typeof el.mozRequestFullScreen === 'function') ||
    ('webkitRequestFullscreen' in el && typeof el.webkitRequestFullscreen === 'function')
  );
}

export function isFullscreen(): boolean {
  return (
    ('fullscreenElement' in document && !!document.fullscreenElement) ||
    ('mozFullScreenElement' in document && !!document.mozFullScreenElement) ||
    ('webkitFullscreenElement' in document && !!document.webkitFullscreenElement)
  );
}

export function openFullscreen(element: HTMLElement): void {
  if ('requestFullscreen' in element && typeof element.requestFullscreen === 'function') {
    element.requestFullscreen();
  } else if ('mozRequestFullScreen' in element && typeof element.mozRequestFullScreen === 'function') {
    element.mozRequestFullScreen();
  } else if ('webkitRequestFullscreen' in element && typeof element.webkitRequestFullscreen === 'function') {
    try {
      // @ts-expect-error Expected type error
      element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    } catch {
      element.webkitRequestFullscreen();
    }
  } else {
    console.warn(`fullscreen is not supported`);
  }
}

export function cancelFullscreen(): void {
  if ('cancelFullScreen' in document && typeof document.cancelFullScreen === 'function') {
    document.cancelFullScreen();
  } else if ('mozCancelFullScreen' in document && typeof document.mozCancelFullScreen === 'function') {
    document.mozCancelFullScreen();
  } else if ('webkitCancelFullScreen' in document && typeof document.webkitCancelFullScreen === 'function') {
    document.webkitCancelFullScreen();
  } else {
    console.warn(`fullscreen is not supported`);
  }
}

export function toggleFullscreen(element: HTMLElement): void {
  return isFullscreen() ? cancelFullscreen() : openFullscreen(element);
}
